import { createSelector } from 'reselect';
import _keyBy from 'lodash/keyBy';
import { userSelector } from '../../../shared/store/selectors';
import { YES_FLAG } from '../../../shared/constants';
import { countryCodes } from '../constants';

export const obligationsSelector = ({ administration }) =>
  administration.obligations.obligations;

export const uploadedObligationsSelector = ({ administration }) =>
  administration.obligations.uploadedObligations;

export const obligationBasedInitialDataSelector = createSelector(
  obligationsSelector,
  obligations => _keyBy(obligations, 'companyCode')
);

export const isLoadingUploadedObligationsSelector = ({ administration }) =>
  administration.obligations.isLoadingUploadedObligations;

export const isLoadingObligationsSelector = ({ administration }) =>
  administration.obligations.isLoadingObligations;

export const isLoadingUserAssignedCompanyCodesSelector = ({ administration }) =>
  administration.obligations.isLoadingUserAssignedCompanyCodes;

export const isLoadingLookUpDataSelector = ({ administration }) =>
  administration.obligations.isLoadingLookUpData;

export const isUpdatingObligationsSelector = ({ administration }) =>
  administration.obligations.isLoadingObligationUpdate;

export const isCreatingObligationsSelector = ({ administration }) =>
  administration.obligations.isLoadingObligationCreate;

export const isImportingObligationsSelector = ({ administration }) =>
  administration.obligations.isLoadingObligationImport;

export const isRemovingObligationSelector = ({ administration }) =>
  administration.obligations.isLoadingObligationRemove;

export const canModifyAllObligationsSelector = state => state.user.user.permissions.commands.canEditAllObligations;

const lookUpDataCompanyCodesSelector = ({ administration }) =>
  administration.obligations.lookUpData.companyCodeOptions || [];

const userAssignedCompanyCodesSelector = ({ administration }) =>
  administration.obligations.userAssignedCompanyCodes;

const userAssignedCompanyCodesSetSelector = createSelector(
  userAssignedCompanyCodesSelector,
  companyCodes => new Set(companyCodes.map(({ companyCode }) => companyCode))
);

const userAssignedCompanyCodesOptionsSelector = createSelector(
  userAssignedCompanyCodesSetSelector,
  lookUpDataCompanyCodesSelector,
  (restrictedCompanyCodesSet, companyCodeOptions) =>
    companyCodeOptions.filter(({ value }) => restrictedCompanyCodesSet.has(value))
);


const companyCodeOptionsSelector = createSelector(
  canModifyAllObligationsSelector,
  lookUpDataCompanyCodesSelector,
  userAssignedCompanyCodesOptionsSelector,
  (canModifyAllObligations, allCompanyCodesOptions, userAssignedCompanyCodeOptions) =>
    canModifyAllObligations
      ? allCompanyCodesOptions
      : userAssignedCompanyCodeOptions
);

export const companyCodeBasedInitialDataSelector = createSelector(
  companyCodeOptionsSelector,
  companyCodes => _keyBy(companyCodes, 'value')
);

export const lookUpDataSelector = createSelector(
  ({ administration }) => administration.obligations.lookUpData,
  companyCodeOptionsSelector,
  (lookUpData, companyCodeOptions) => ({
    ...lookUpData,
    companyCodeOptions,
    homeOfficeCompanyCodeOptions: companyCodeOptions ? companyCodeOptions.filter(companyCode =>
      companyCode.associatedLeCountryCode === countryCodes.US && companyCode.enabledFlag === YES_FLAG
    ): [],
  })
);

export const canEditTaxCurrencySubledgerSelector = createSelector(
  userSelector,
  user => user.permissions.menus.administration.subMenu.obligations.canEditTaxCurrencySubledger
);
